import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Icon from "common/components/Icon"
import TesoreriaService from "common/services/TesoreriaService"
import {
  FechaBodyTemplate,
  ImporteBodyTemplate,
} from "features/Documentos/templates"
import { nanoid } from "nanoid"

export const getColumns = (
  isInDetailView: $TSMigrationFixMe,
  handleEditModal: $TSMigrationFixMe,
  handleOpenDeleteModal: $TSMigrationFixMe,
  t: $TSMigrationFixMe
) => {
  const columns = [
    {
      key: nanoid(),
      header: `${t("devoluciones.tab.headerNum")}`,
      sortable: true,
      body: ({ identificador }: $TSMigrationFixMe) => (
        <span>{identificador}</span>
      ),
      filter: false,
      field: "numero",
      className: "text-left",
      customFilter: {
        type: "input",
        name: "SerieNumero",
      },
    },
    {
      key: nanoid(),
      header: `${t("devoluciones.tab.headerDate")}`,
      sortable: true,
      filter: false,
      body: FechaBodyTemplate,
      field: "fecha",
      customFilter: {
        type: "date",
        name: "fecha",
      },
      isInDetailView: true,
      headerStyle: {
        width: 150,
      },
    },
    {
      key: nanoid(),
      header: `${t("devoluciones.tab.headerClient")}`,
      sortable: true,
      filter: false,
      body: ({ razonSocial }: $TSMigrationFixMe) => (
        <span className='serie'>{razonSocial}</span>
      ),
      customFilter: {
        type: "input",
        name: "razonSocial",
      },
      headerStyle: {
        width: 400,
      },
    },
    {
      key: nanoid(),
      header: `${t("devoluciones.tab.headerDescription")}`,
      sortable: true,
      body: ({ descripcion }: $TSMigrationFixMe) => {
        return <p>{descripcion}</p>
      },
      field: "descripcion",
      className: "decription-table",
    },
    {
      key: nanoid(),
      header: `${t("devoluciones.tab.headerTax")}`,
      sortable: true,
      body: ImporteBodyTemplate,
      field: "total",
      className: "text-right",
      headerStyle: {
        width: 250,
      },
    },
    {
      key: nanoid(),
      header: `${t("devoluciones.tab.headerRemittance")}`,
      sortable: true,
      body: ({ remesado }: $TSMigrationFixMe) => {
        return (
          <div>
            <FontAwesomeIcon
              icon={["fal", `${remesado ? "check" : "xmark"}`]}
              className={remesado ? "icon-check" : "icon-xmark"}
            />
          </div>
        )
      },
      field: "total",
      className: "text-center",
      headerStyle: {
        width: 250,
      },
    },
    {
      key: nanoid(),
      header: "",
      body: (rowData: $TSMigrationFixMe) => {
        return (
          <div className='d-flex justify-content-center w-100 g-2'>
            <div
              className='px-1'
              onClick={() => handleEditModal(rowData, true)}
            >
              <Icon
                bordered
                iconColor='#535c72'
                className='px-1'
              >
                <FontAwesomeIcon
                  icon={["fal", "pen"]}
                  className='primary'
                />
              </Icon>
            </div>
            <div
              className='px-1'
              onClick={() => handleOpenDeleteModal(rowData, true)}
            >
              <Icon
                bordered
                iconColor='#535c72'
                className='px-5'
              >
                <FontAwesomeIcon
                  icon={["fal", "trash-can"]}
                  className='icon-delete'
                />
              </Icon>
            </div>
          </div>
        )
      },
      field: "total",
      className: "text-center",
      headerStyle: {
        width: 100,
      },
    },
  ]
  const detailViewColumns = columns.filter((column) => column.isInDetailView)

  return isInDetailView ? detailViewColumns : columns
}

export const getModalSetup = (
  showDelete: $TSMigrationFixMe,
  setShowDelete: $TSMigrationFixMe,
  handleDelete: $TSMigrationFixMe,
  modeDetails: $TSMigrationFixMe,
  t: $TSMigrationFixMe
) => {
  const MODAL_SETUP = {
    delete: handleDelete,
    setShow: setShowDelete,
    show: showDelete,
    image: "remesas",
    msj: `${t("devoluciones.delete.msgLabel")}`,
    title: modeDetails,
  }
  return MODAL_SETUP
}

export const getDevolucionDataById = ({ id }: $TSMigrationFixMe) => {
  return TesoreriaService.getDevolucionesById(id)
}

export const modificateDevolucionValues = (values: $TSMigrationFixMe) => {
  const newValue = {
    ...values,
    ...{ devolucionIds: values.facturaIds },
  }
  delete newValue.tipo
  delete newValue.facturaIds
  return newValue
}
